import { render, staticRenderFns } from "./EstrelaGrandeIcon.vue?vue&type=template&id=d01484f6&scoped=true"
import script from "./EstrelaGrandeIcon.vue?vue&type=script&lang=js"
export * from "./EstrelaGrandeIcon.vue?vue&type=script&lang=js"
import style0 from "./EstrelaGrandeIcon.vue?vue&type=style&index=0&id=d01484f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01484f6",
  null
  
)

export default component.exports